import React, { Component } from 'react'
import axios from 'axios'
import { findIndex } from 'lodash'
import { connect } from 'react-redux'
import RankingList from '../components/rankingList'
import RankingTop from '../components/rankingTop'
import RankingPosition from '../components/rankingPosition'
import Header from '../components/header'
import { t } from 'i18next'

import { PROXY } from '../config'
import Loading from '../components/Loading'

class Ranking extends Component {
  state = {
    fetching: true,
    data: null
  }

  componentDidMount() {
    const { user } = this.props
    const { score } = user
    const url = score > 0 ? `${PROXY}/ranking/${score}` : `${PROXY}/ranking`

    axios
      .get(url)
      .then(response => {
        this.setState({
          fetching: false,
          data: response.data
        })
      })
      .catch(err => console.error(err))
  }

  renderRanking() {
    const { data } = this.state
    const { ranking } = data
    const { viewPage } = this.props

    const rankingTop = ranking.slice(0, 3)
    const rankingList = ranking.slice(3)

    return (
      <div style={{ width: '100%', height: '100vh', overflowY: 'auto', position: 'relative' }}>
        <div className="gif" />
        <Header viewPage={viewPage}>
          <h3>{t('ranking.header')}</h3>
        </Header>
        <RankingTop top={rankingTop} />
        <RankingList list={rankingList} />
      </div>
    )
  }

  renderPosition() {
    const { data } = this.state
    const { positions, ranking } = data
    const { user } = this.props

    const top20 = findIndex(ranking, function(o) {
      return o.id === user.id
    })

    const searchPosition = (ranking, index) => {
      if (index < 3) {
        return index + 1
      }

      let position = 4
      const subranking = ranking.slice(position - 1)
      let lastScore = subranking[0].score

      subranking.forEach(o => {
        if (o.score >= user.score) {
          position = o.score !== lastScore ? position + 1 : position
          lastScore = o.score
        }
      })

      return position
    }

    const position =
      top20 >= 0
        ? searchPosition(ranking, top20)
        : positions.length > 0
          ? positions.reduce((memo, p) => {
              return memo + p.users
            }, 0) + 1
          : 1

    return <RankingPosition name={user.name} position={position} />
  }

  render() {
    const { fetching } = this.state
    const { user } = this.props
    const { exists } = user

    return fetching ? (
      <div className="view-inner">
        <Loading width="100%" height="100%" />
      </div>
    ) : (
      <div className="view-inner">
        {this.renderRanking()}
        {exists && this.renderPosition()}
      </div>
    )
  }
}

const mapState = state => {
  const { user } = state
  return {
    user
  }
}

const Connect = connect(mapState)(Ranking)
Connect.displayName = 'ranking-home'

export default Connect



// WEBPACK FOOTER //
// ./src/pages/RankingHome.js